<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Contracted Within</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class="">
        <div class="card-body p-2">
            <p class="mt-1">
                <strong>Contracted Within</strong> is an additional option for the Contract Length
                <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Market Metrics')">market
                    metric</span>

                in Xeneta's Ocean offering that lets you exclude market rates coming from older contracts from being
                shown in the platform.
            </p>
            <p>
                To measure global trends, Xeneta aggregates trade lane rates by looking at both short and long term
                contracts separately. When viewing freight rates as set by long term contracts, the rate on any trade
                lane for a single day may come from a combination of contracts signed anywhere from a day ago to several
                months ago.
            </p>
            <p>
                <img src="../../../../../assets/img/filters.png" class="fr-fic fr-dib" style="width: 100%;">
            </p>
            <p>
                If you find that contracts from several months ago do not reflect the current market rate,
                <strong>Contracted Within</strong> provides you with three additional options for filtering long-term
                contracts based on their age:
            </p>
            <ul>
                <li>
                    <strong>All Contracts&nbsp;</strong> — displays all long-term contracts that are valid for any given
                    date&nbsp;
                </li>
                <li>
                    <strong>Contracted Within Last 3 Months</strong> — displays only rates from valid contracts that
                    began no more than 3 months ago
                </li>
                <li>
                    <strong>Contracted Within Last 6 Months</strong> — displays only rates from valid contracts that
                    began no more than 6 months ago
                </li>
            </ul>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">We recommend starting any rate benchmark with the
                <strong>Contracted Within Last 3 Months</strong> option. Otherwise you may find some valid long term
                contracts that
                began months ago, and no longer reflect the current market rates, giving you a distorted view of the
                market.
            </blockquote>
            <h2>Contract Age and Today's Rate</h2>
            <p>Let's look at an example where a search on a trade lane has returned five contract rates. Each contract
                starts and ends at a different time, and each contract has a different freight rate associated with it.
            </p>
            <p><img src="https://cdn.elev.io/file/uploads/rOALFOXLKP1cK0vUfMBO8anLllDZ1qoVgZG5L2at3Rs/8LwA7Z3wLKuqz8OsX1rqY2qssP5hspdGw5Te-wwVYLs/contracted_within_diagram-W5U.png"
                    alt="contracted_within_diagram.png" class="fr-fic fr-dii"></p>
            <p>Depending on which <strong>Contracted Within</strong> option you select for this search, the rate you see
                in Xeneta will be different:</p>
            <ul>
                <li><strong>All Contracts&nbsp;</strong>will show the final rate for today as a combination of contracts
                    <strong>2</strong>, <strong>3</strong>, <strong>4</strong>, <strong>5</strong>, and
                    <strong>6</strong>
                </li>
                <li><strong>Contracted Within Last 6 Months&nbsp;</strong>will show the final rate as a combination of
                    contracts <strong>2</strong>, <strong>3</strong>, <strong>4</strong>, and <strong>5</strong></li>
                <li><strong>Contracted Within Last 3 Months&nbsp;</strong>will show the final rate as a combination of
                    contracts <strong>3</strong>, <strong>4</strong>, and <strong>5</strong>.</li>
            </ul>
            <blockquote class="my-4 p-3 bg-yellow-100 color-block"><strong>Contract 1</strong> is not factored into any
                calculation
                because it's not valid as of <strong>T</strong><strong>oday</strong>.</blockquote>
            <blockquote class="my-4 p-3 bg-gray-300 color-block">
                <p class="p-0 m-0">In this example, we use only 6 contract rates for illustration purposes. In practice,
                    Xeneta needs a
                    minimum of 5 rate data points across 2 different providers to show a benchmark rate for any date.
                </p>
            </blockquote>
            <p>This ability to filter out rates based on the age of their associated contracts offers you an additional
                way to only see the rates that are most relevant to you.</p>
        </div>
    </div>
</article>